import { FC } from 'react';

import { concatClassNames, formatTime } from '../../../../utils/utilities';
import { getCustomLPTColumns } from '../../../../utils/data';
import { CustomLPTReport } from '../../../../utils/models';
import { APP_DATE_FORMAT } from '../../../../utils/constants';

import Conditional from '../../../common/conditional';
import PDFTablePage from '../../../themed/pdf/pdfTablePage';

import css from './style.module.scss';

interface Props extends CustomLPTReport {
	showOverview: boolean;
	showSummary: boolean;
}

const LPTReportSummary: FC<Props> = (props) => {
	return (
		<div className={css.lptReport}>
			<Conditional isVisible={props.showOverview}>
				<div className="container-fluid overflow-hidden">
					<div className="row">
						<div className="col">
							<div className="row">
								<div className={concatClassNames([css.lptReportHeader, 'col-5'])}>
									Surface Condition
								</div>
								<div className={concatClassNames([css.lptReportBody, 'col'])}>
									{props.surfaceCondition}
								</div>
							</div>

							<div className="row">
								<div className={concatClassNames([css.lptReportHeader, 'col-5'])}>
									Stage of test
								</div>
								<div className={concatClassNames([css.lptReportBody, 'col'])}>
									{props.stageOfTest}
								</div>
							</div>

							<div className="row">
								<div className={concatClassNames([css.lptReportHeader, 'col-5'])}>
									Equipment
								</div>
								<div className={concatClassNames([css.lptReportBody, 'col'])}>
									{props.equipment}
								</div>
							</div>

							<div className="row">
								<div className={concatClassNames([css.lptReportHeader, 'col-5'])}>
									Light Intensity
								</div>
								<div className={concatClassNames([css.lptReportBody, 'col'])}>
									{props.light}
								</div>
							</div>

							<div className='row'>
								<div className={concatClassNames([css.lptReportHeader, 'col-5'])}>
									Penetrant
								</div>
								<div className={concatClassNames([css.lptReportBody, 'col'])}>
									{props.penetrant}
								</div>
							</div>
						</div>

						<div className="col">
							<div className="row">
								<div className={concatClassNames([css.lptReportHeader, 'col-5'])}>
									Method
								</div>
								<div className={concatClassNames([css.lptReportBody, 'col'])}>
									{props.method}
								</div>
							</div>

							<div className="row">
								<div className={concatClassNames([css.lptReportHeader, 'col-5'])}>
									Developer
								</div>
								<div className={concatClassNames([css.lptReportBody, 'col'])}>
									{props.developer}
								</div>
							</div>

							<div className="row">
								<div className={concatClassNames([css.lptReportHeader, 'col-5'])}>
									Surface Temperature
								</div>
								<div className={concatClassNames([css.lptReportBody, 'col'])}>
									{props.surfaceTemperature}
								</div>
							</div>

							<div className="row">
								<div className={concatClassNames([css.lptReportHeader, 'col-5'])}>
									Technique
								</div>
								<div className={concatClassNames([css.lptReportBody, 'col'])}>
									{props.technique}
								</div>
							</div>

							<div className="row">
								<div className={concatClassNames([css.lptReportHeader, 'col-5'])}>
									Penetrant Remover
								</div>
								<div className={concatClassNames([css.lptReportBody, 'col'])}>
									{props.penetrantRemover}
								</div>
							</div>
						</div>
					</div>
				</div>
				
				<Conditional isVisible={false}>
					<div className={css.lptReportSection}></div>
				</Conditional>

				<div className="container-fluid overflow-hidden">
					<div className="row">
						<div className="col">
							<div className="row">
								<div className={concatClassNames([css.lptReportHeader, 'col-5'])}>
									Penetrant Batch No.
								</div>
								<div className={concatClassNames([css.lptReportBody, 'col'])}>
									{props.penetrantBatchNumber}
								</div>
							</div>

							<div className='row'>
								<div className={concatClassNames([css.lptReportHeader, 'col-5'])}>
									Penetrant Remover Batch No.
								</div>
								<div className={concatClassNames([css.lptReportBody, 'col'])}>
									{props.penetrantRemoverBatchNumber}
								</div>
							</div>

							<div className="row">
								<div className={concatClassNames([css.lptReportHeader, 'col-5'])}>
									Developer Batch No.
								</div>
								<div className={concatClassNames([css.lptReportBody, 'col'])}>
									{props.developerBatchNumber}
								</div>
							</div>

							<div className="row">
								<div className={concatClassNames([css.lptReportHeader, 'col-5'])}>
									Lux Meter Model
								</div>
								<div className={concatClassNames([css.lptReportBody, 'col'])}>
									{props.modal}
								</div>
							</div>
						</div>

						<div className="col">
							<div className="row">
								<div className={concatClassNames([css.lptReportHeader, 'col-5'])}>
									Penetrant Expiry Date
								</div>
								<div className={concatClassNames([css.lptReportBody, 'col'])}>
									{props.penetrantExpiryDate ? formatTime(props.penetrantExpiryDate, APP_DATE_FORMAT) : 'N/A'}
								</div>
							</div>

							<div className="row">
								<div className={concatClassNames([css.lptReportHeader, 'col-5'])}>
									Penetrant Remover Expiry Date
								</div>
								<div className={concatClassNames([css.lptReportBody, 'col'])}>
									{props.penetrantRemoverExpiryDate ? formatTime(props.penetrantRemoverExpiryDate, APP_DATE_FORMAT) : 'N/A'}
								</div>
							</div>
							
							<div className="row">
								<div className={concatClassNames([css.lptReportHeader, 'col-5'])}>
									Developer Expiry Date
								</div>
								<div className={concatClassNames([css.lptReportBody, 'col'])}>
									{props.developerExpiryDate ? formatTime(props.developerExpiryDate, APP_DATE_FORMAT) : 'N/A'}
								</div>
							</div>

							<div className='row'>
								<div className={concatClassNames([css.lptReportHeader, 'col-5'])}>
									Lux Meter Serial No.
								</div>
								<div className={concatClassNames([css.lptReportBody, 'col'])}>
									{props.serialNumber}
								</div>
							</div>
						</div>
					</div>
				</div>

				<Conditional isVisible={false}>
					<div className={css.lptReportSection}></div>
				</Conditional>

				<div className="container-fluid overflow-hidden">
					<div className="row">
						<div className="col">
							<div className="row">
								<div className={concatClassNames([css.lptReportHeader, 'col-5'])}>
									Light Meter Calibration Date
								</div>
								<div className={concatClassNames([css.lptReportBody, 'col'])}>
									{props.calibrationDueDate ? formatTime(props.calibrationDueDate, APP_DATE_FORMAT) : 'N/A'}
								</div>
							</div>
						</div>

						<div className="col">
							<div className="row">
								<div className={concatClassNames([css.lptReportHeader, 'col-5'])}>
									Date of Inspection
								</div>
								<div className={concatClassNames([css.lptReportBody, 'col'])}>
									{props.dateOfInspection ? formatTime(props.dateOfInspection, APP_DATE_FORMAT) : 'N/A'}
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="container-fluid overflow-hidden">
					<div className="row">
						<div className="col">
							<div className="row">
								<div className={concatClassNames([css.lptReportHeader, 'col-5'])}>
									Material
								</div>
								<div className={concatClassNames([css.lptReportBody, 'col'])}>
									{props.material}
								</div>
							</div>
							
							<div className="row">
								<div className={concatClassNames([css.lptReportHeader, 'col-5'])}>
									Aerosols Type
								</div>
								<div className={concatClassNames([css.lptReportBody, 'col'])}>
									{props.aerosolsType}
								</div>
							</div>
						</div>

						<div className="col">
							<div className="row">
								<div className={concatClassNames([css.lptReportHeader, 'col-5'])}>
									Dwell Time
								</div>
								<div className={concatClassNames([css.lptReportBody, 'col'])}>
									{props.dwellTime}
								</div>
							</div>

							<div className="row">
								<div className={concatClassNames([css.lptReportHeader, 'col-5'])}>
									Developing Time
								</div>
								<div className={concatClassNames([css.lptReportBody, 'col'])}>
									{props.developingTime}
								</div>
							</div>
						</div>
					</div>
				</div>
				
				<Conditional isVisible={false}>
					<div className={css.lptReportSection}></div>
				</Conditional>
			</Conditional>


			<Conditional isVisible={false}>
				<div className={css.lptReportSection}></div>
			</Conditional>

			<PDFTablePage data={props.data} columns={getCustomLPTColumns()} />

			<Conditional isVisible={false}>
				<div className={css.lptReportSection}></div>
			</Conditional>

			<Conditional isVisible={false}>
				<div className="container-fluid overflow-hidden">
					<div className="row">
						<div className={concatClassNames([css.lptReportHeader, 'col-5'])}>
							Summary
						</div>
						<div className={concatClassNames([css.lptReportBody, 'col'])}>
							{props.summary}
						</div>
					</div>
				</div>
			</Conditional>
		</div>
	);
};

export default LPTReportSummary;
